import script from "./ServicesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesGrid.vue?vue&type=script&setup=true&lang=js"

import "./ServicesGrid.vue?vue&type=style&index=0&id=79d41018&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d41018"]])

export default __exports__